import { observer } from 'mobx-react-lite';
import SecondaryConfirm from './index';
import { Divider } from 'antd';
const TaskConfirm = observer<{
  type: string;
  handleAction: () => void;
  title?: string;
  text?: string;
  cancelBtn?: string;
  confirmBtn?: string;
}>(({ text, handleAction, title, cancelBtn, confirmBtn }) => {
  return (
    <div className="private-confirm w-400px">
      <div className="flex flex-col">
        <div className="text-24px leading-28px font-bold px-24px pt-20px">
          {title}
        </div>
        <Divider />
        <div className="text-16px px-24px">{text}</div>
        <div className="mt-20px flex justify-end gap-12px px-24px py-20px">
          <div
            className="w-96px h-40px flex items-center justify-center bg-[rgba(0,0,0,0.06)] hover:bg-[rgb(0,0,0,.12)] rounded-10px cursor-pointer"
            onClick={() => SecondaryConfirm.close()}
          >
            {cancelBtn}
          </div>
          <div
            className="w-96px h-40px text-[#ffffff] flex items-center justify-center bg-[#000000] hover:bg-[rgb(0,0,0,.8)] rounded-10px cursor-pointer"
            onClick={handleAction}
          >
            {confirmBtn}
          </div>
        </div>
      </div>
    </div>
  );
});
export default TaskConfirm;
